import React, { useEffect, useMemo, useState } from "react";

const API_BASE = "https://panel.haymestasarim.com/api";

function tokenHeader() {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

const TEXT = {
  tr: {
    title: "💰 Kasa & Tahsilat",
    subtitle: "Tüm işletmeler için gelir, gider, tahsilat ve günlük kasa takibi.",
    today: "Bugün",
    week: "Bu Hafta",
    month: "Bu Ay",
    cash: "Nakit",
    card: "Kart",
    bank: "Banka",
    totalRecords: "Kayıt",
    add: "İşlem Ekle",
    edit: "Düzenle",
    delete: "Sil",
    save: "Kaydet",
    update: "Güncelle",
    cancel: "Vazgeç",
    print: "Yazdır / PDF",
    csv: "CSV İndir",
    titleField: "İşlem Başlığı",
    category: "Kategori",
    type: "İşlem Tipi",
    income: "Gelir",
    expense: "Gider",
    quantity: "Adet",
    unitPrice: "Birim Fiyat",
    total: "Toplam",
    currency: "Para Birimi",
    paymentMethod: "Ödeme Türü",
    customer: "Müşteri",
    staff: "Personel",
    date: "Tarih",
    note: "Not",
    filter: "Filtrele",
    all: "Tümü",
    module: "Kaynak",
    manual: "Manuel",
    beauty: "Beauty",
    menu: "QR Menü",
    appointment: "Randevu",
    noRecord: "Henüz kayıt yok.",
    topItems: "En Çok Gelir Getiren İşlemler",
    list: "Kasa Hareketleri",
    report: "Rapor",
    required: "Başlık zorunlu.",
    confirmDelete: "Bu kaydı silmek istiyor musun?",
  },
  en: {
    title: "💰 Cash & Collections",
    subtitle: "Income, expense, collections and daily cash tracking for every business.",
    today: "Today",
    week: "This Week",
    month: "This Month",
    cash: "Cash",
    card: "Card",
    bank: "Bank",
    totalRecords: "Records",
    add: "Add Transaction",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    update: "Update",
    cancel: "Cancel",
    print: "Print / PDF",
    csv: "Download CSV",
    titleField: "Transaction Title",
    category: "Category",
    type: "Transaction Type",
    income: "Income",
    expense: "Expense",
    quantity: "Quantity",
    unitPrice: "Unit Price",
    total: "Total",
    currency: "Currency",
    paymentMethod: "Payment Method",
    customer: "Customer",
    staff: "Staff",
    date: "Date",
    note: "Note",
    filter: "Filter",
    all: "All",
    module: "Source",
    manual: "Manual",
    beauty: "Beauty",
    menu: "QR Menu",
    appointment: "Appointment",
    noRecord: "No records yet.",
    topItems: "Top Revenue Items",
    list: "Cash Transactions",
    report: "Report",
    required: "Title is required.",
    confirmDelete: "Do you want to delete this record?",
  },
  de: {
    title: "💰 Kasse & Zahlungen",
    subtitle: "Einnahmen, Ausgaben, Zahlungen und Tageskasse für jedes Unternehmen.",
    today: "Heute",
    week: "Diese Woche",
    month: "Dieser Monat",
    cash: "Bar",
    card: "Karte",
    bank: "Bank",
    totalRecords: "Einträge",
    add: "Eintrag hinzufügen",
    edit: "Bearbeiten",
    delete: "Löschen",
    save: "Speichern",
    update: "Aktualisieren",
    cancel: "Abbrechen",
    print: "Drucken / PDF",
    csv: "CSV herunterladen",
    titleField: "Titel",
    category: "Kategorie",
    type: "Typ",
    income: "Einnahme",
    expense: "Ausgabe",
    quantity: "Menge",
    unitPrice: "Einzelpreis",
    total: "Gesamt",
    currency: "Währung",
    paymentMethod: "Zahlungsart",
    customer: "Kunde",
    staff: "Personal",
    date: "Datum",
    note: "Notiz",
    filter: "Filtern",
    all: "Alle",
    module: "Quelle",
    manual: "Manuell",
    beauty: "Beauty",
    menu: "QR Menü",
    appointment: "Termin",
    noRecord: "Noch keine Einträge.",
    topItems: "Umsatzstärkste Einträge",
    list: "Kassenbewegungen",
    report: "Bericht",
    required: "Titel ist erforderlich.",
    confirmDelete: "Möchten Sie diesen Eintrag löschen?",
  },
};

const emptyForm = {
  module_type: "manual",
  transaction_type: "income",
  title: "",
  category: "",
  quantity: "1",
  unit_price: "",
  total_amount: "",
  currency: "TRY",
  payment_method: "cash",
customer_key: "",
customer_id: "",
customer_name: "",
staff_name: "",
note: "",
  transaction_date: new Date().toISOString().slice(0, 10),
};

const paymentLabels = {
  cash: { tr: "Nakit", en: "Cash", de: "Bar" },
  card: { tr: "Kart", en: "Card", de: "Karte" },
  bank: { tr: "Banka", en: "Bank", de: "Bank" },
};

const moduleLabels = {
  manual: { tr: "Manuel", en: "Manual", de: "Manuell" },
  beauty: { tr: "Beauty", en: "Beauty", de: "Beauty" },
  menu: { tr: "QR Menü", en: "QR Menu", de: "QR Menü" },
  appointment: { tr: "Randevu", en: "Appointment", de: "Termin" },
};

function getLang() {
  const raw =
    localStorage.getItem("panel_dili") ||
    localStorage.getItem("app_lang") ||
    localStorage.getItem("lang") ||
    "tr";
  const l = raw.slice(0, 2).toLowerCase();
  return ["tr", "en", "de"].includes(l) ? l : "tr";
}

function money(value, currency = "TRY") {
  const n = Number(value || 0);
  return `${n.toLocaleString("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${currency || ""}`;
}

export default function KasaPanel() {
  const [lang, setLang] = useState(getLang());
  const TT = TEXT[lang] || TEXT.tr;

const [loading, setLoading] = useState(true);
const [records, setRecords] = useState([]);
const [summary, setSummary] = useState(null);
const [topItems, setTopItems] = useState([]);
const [customers, setCustomers] = useState([]);
const [beautyCategories, setBeautyCategories] = useState([]);

  const [form, setForm] = useState(emptyForm);
  const [editingId, setEditingId] = useState(null);

  const [filters, setFilters] = useState({
    q: "",
    type: "all",
    payment: "all",
    module: "all",
    start: "",
    end: "",
  });

  useEffect(() => {
    const syncLang = () => setLang(getLang());
    window.addEventListener("app_lang_change", syncLang);
    window.addEventListener("storage", syncLang);
    return () => {
      window.removeEventListener("app_lang_change", syncLang);
      window.removeEventListener("storage", syncLang);
    };
  }, []);

  const loadAll = async () => {
    setLoading(true);
    try {
      const [listRes, reportRes] = await Promise.all([
        fetch(`${API_BASE}/cash`, { headers: tokenHeader() }),
        fetch(`${API_BASE}/cash/reports/summary`, { headers: tokenHeader() }),
      ]);

      const listJson = await listRes.json().catch(() => ({}));
      const reportJson = await reportRes.json().catch(() => ({}));

      setRecords(listJson.data || []);
      setSummary(reportJson.data?.summary || null);
      setTopItems(reportJson.data?.top_items || []);
    } catch (err) {
      console.error("Kasa yüklenemedi:", err);
    } finally {
      setLoading(false);
    }
  };



const normalizeCustomerKey = (customer = {}) => {
  const phone = String(customer.phone || "").replace(/\D/g, "");
  if (phone) return `phone:${phone}`;

  const name = String(customer.full_name || customer.name || "")
    .trim()
    .toLowerCase();

  return name ? `name:${name}` : `row:${customer.id || Math.random()}`;
};

const loadCashCustomers = async () => {
  try {
    const [beautyRes, cariRes] = await Promise.all([
      fetch(`${API_BASE}/beaty/pro/customers`, { headers: tokenHeader() }),
      fetch(`${API_BASE}/cari/customers?limit=1000`, { headers: tokenHeader() }),
    ]);

    const beautyJson = await beautyRes.json().catch(() => ({}));
    const cariJson = await cariRes.json().catch(() => ({}));

    const mergedMap = new Map();

    // Önce Cari eklenir. Kasa ve Cari hareketlerinde asıl ID Cari ID olmalı.
    (cariJson.data || []).forEach((c) => {
      const key = normalizeCustomerKey(c);

      mergedMap.set(key, {
        ...c,
        display_key: key,
        customer_source: c.beaty_customer_id ? "cari+beauty" : "cari",
        customer_id_for_cash: c.id,
        customer_id_for_beauty: c.beaty_customer_id || null,
        full_name: c.full_name || "",
        phone: c.phone || "",
      });
    });

    // Sonra Beauty eklenir veya mevcut Cari kaydıyla birleştirilir.
    (beautyJson.data || []).forEach((c) => {
      const key = normalizeCustomerKey(c);
      const existing = mergedMap.get(key);

      if (existing) {
        mergedMap.set(key, {
          ...existing,
          customer_source: "cari+beauty",
          customer_id_for_beauty: existing.customer_id_for_beauty || c.id,
          full_name: existing.full_name || c.full_name || c.name || "",
          phone: existing.phone || c.phone || "",
        });
        return;
      }

      mergedMap.set(key, {
        ...c,
        display_key: key,
        customer_source: "beauty",
        customer_id_for_cash: null,
        customer_id_for_beauty: c.id,
        full_name: c.full_name || c.name || "",
        phone: c.phone || "",
      });
    });

    setCustomers(Array.from(mergedMap.values()));


  } catch (err) {
    console.log("Kasa müşteri listesi gelmedi:", err);
  }
};

const loadBeautyCategories = async () => {
  try {
    const res = await fetch(`${API_BASE}/beaty/categories`, {
      headers: tokenHeader(),
    });

    const json = await res.json().catch(() => ({}));
    setBeautyCategories(json.data || []);
  } catch (err) {
    console.log("Beauty kategori listesi gelmedi:", err);
  }
};

useEffect(() => {
  loadAll();
  loadCashCustomers();
  loadBeautyCategories();
}, []);


  const calculatedTotal = useMemo(() => {
    const qty = Number(form.quantity || 1);
    const unit = Number(form.unit_price || 0);
    return qty * unit;
  }, [form.quantity, form.unit_price]);

  const filteredRecords = useMemo(() => {
    return records.filter((r) => {
      const q = filters.q.trim().toLowerCase();
      const haystack = [
        r.title,
        r.category,
        r.customer_name,
        r.staff_name,
        r.note,
        r.payment_method,
        r.module_type,
      ]
        .join(" ")
        .toLowerCase();

      if (q && !haystack.includes(q)) return false;
      if (filters.type !== "all" && r.transaction_type !== filters.type) return false;
      if (filters.payment !== "all" && r.payment_method !== filters.payment) return false;
      if (filters.module !== "all" && r.module_type !== filters.module) return false;
      if (filters.start && String(r.transaction_date).slice(0, 10) < filters.start) return false;
      if (filters.end && String(r.transaction_date).slice(0, 10) > filters.end) return false;

      return true;
    });
  }, [records, filters]);

  const filteredTotals = useMemo(() => {
    return filteredRecords.reduce(
      (acc, r) => {
        const val = Number(r.total_amount || 0);
        if (r.transaction_type === "expense") acc.expense += val;
        else acc.income += val;
        return acc;
      },
      { income: 0, expense: 0 }
    );
  }, [filteredRecords]);

const saveRecord = async () => {
  if (!form.title.trim()) {
    alert(TT.required);
    return;
  }

  const amount = Number(form.total_amount || calculatedTotal || 0);

  if (amount <= 0) {
    alert("Tutar sıfır olamaz");
    return;
  }

  try {
    // BEAUTY seçildiyse sadece Beauty tahsilatına gönder.
    // Backend bunu zaten rapora, cariye ve kasaya işler.
    // Böylece çift kasa kaydı oluşmaz.
    if (form.module_type === "beauty" && !editingId) {
      if (!form.customer_id) {
        alert("Müşteri seçmelisin");
        return;
      }

      const payRes = await fetch(`${API_BASE}/beaty/pro/payments`, {
        method: "POST",
        headers: tokenHeader(),
        body: JSON.stringify({
          customer_id: form.customer_id,
          customer_package_id: null,
          amount,
          currency: form.currency || "TRY",
          payment_type: form.payment_method || "cash",
          payment_method: form.payment_method || "cash",
          note: form.note || form.title || "Kasadan tahsilat",
          payment_date: form.transaction_date,
        }),
      });

      const payJson = await payRes.json().catch(() => ({}));

      if (!payRes.ok || payJson.ok === false) {
        alert(payJson.message || "Beauty tahsilatı kaydedilemedi");
        return;
      }

      try {
  await fetch(`${API_BASE}/cari/import-beaty`, {
    method: "POST",
    headers: tokenHeader(),
  });
} catch (err) {
  console.warn("Kasa tahsilatı sonrası Cari eşitleme yapılamadı:", err);
}

setForm(emptyForm);
setEditingId(null);
loadAll();
loadCashCustomers();
return;
    }

    // Beauty dışındaki işlemler normal kasaya kaydolur.
    const body = {
      ...form,
      customer_id: form.customer_id || null,
      customer_name: form.customer_name || "",
      quantity: Number(form.quantity || 1),
      unit_price: Number(form.unit_price || 0),
      total_amount: amount,
    };

    const url = editingId
      ? `${API_BASE}/cash/${editingId}`
      : `${API_BASE}/cash`;

    const method = editingId ? "PUT" : "POST";

    const res = await fetch(url, {
      method,
      headers: tokenHeader(),
      body: JSON.stringify(body),
    });

    const json = await res.json().catch(() => ({}));

    if (!res.ok || json.ok === false) {
      alert(json.message || "Kasa kaydı yapılamadı");
      return;
    }

    setForm(emptyForm);
    setEditingId(null);
    loadAll();
  } catch (err) {
    console.error("Kasa kayıt hatası:", err);
    alert("Sunucuya bağlanılamadı");
  }
};



  const editRecord = (r) => {
    setEditingId(r.id);
    setForm({
      module_type: r.module_type || "manual",
      transaction_type: r.transaction_type || "income",
      title: r.title || "",
      category: r.category || "",
      quantity: String(r.quantity || "1"),
      unit_price: String(r.unit_price || ""),
      total_amount: String(r.total_amount || ""),
      currency: r.currency || "TRY",

   payment_method: r.payment_method || "cash",
customer_key: r.customer_id ? `cari-${r.customer_id}` : "",
customer_id: r.customer_id || "",
customer_name: r.customer_name || "",
staff_name: r.staff_name || "",
      note: r.note || "",
      transaction_date: String(r.transaction_date || "").slice(0, 10) || new Date().toISOString().slice(0, 10),
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const deleteRecord = async (id) => {
    if (!window.confirm(TT.confirmDelete)) return;

    try {
      const res = await fetch(`${API_BASE}/cash/${id}`, {
        method: "DELETE",
        headers: tokenHeader(),
      });

      const json = await res.json().catch(() => ({}));
      if (!res.ok || json.ok === false) {
        alert(json.message || "Silinemedi");
        return;
      }

      loadAll();
    } catch (err) {
      console.error("Kasa silme hatası:", err);
    }
  };

  const exportCSV = () => {
    const rows = [
      [
        TT.date,
        TT.type,
        TT.module,
        TT.titleField,
        TT.category,
        TT.quantity,
        TT.unitPrice,
        TT.total,
        TT.currency,
        TT.paymentMethod,
        TT.customer,
        TT.staff,
        TT.note,
      ],
      ...filteredRecords.map((r) => [
        String(r.transaction_date || "").slice(0, 10),
        r.transaction_type,
        r.module_type,
        r.title,
        r.category,
        r.quantity,
        r.unit_price,
        r.total_amount,
        r.currency,
        r.payment_method,
        r.customer_name,
        r.staff_name,
        r.note,
      ]),
    ];

    const csv = rows
      .map((row) =>
        row
          .map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`)
          .join(";")
      )
      .join("\n");

    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `kasa-tahsilat-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const printReport = () => {
    const html = `
      <html>
        <head>
          <title>${TT.title}</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 28px; color: #111827; }
            h1 { color: #166534; margin-bottom: 4px; }
            .muted { color: #6b7280; margin-bottom: 22px; }
            .cards { display: grid; grid-template-columns: repeat(4,1fr); gap: 12px; margin-bottom: 20px; }
            .card { border: 1px solid #e5e7eb; border-radius: 12px; padding: 14px; }
            .card span { color: #6b7280; font-size: 12px; }
            .card b { display: block; font-size: 20px; margin-top: 4px; }
            table { width: 100%; border-collapse: collapse; margin-top: 16px; font-size: 12px; }
            th, td { border: 1px solid #e5e7eb; padding: 7px; text-align: left; }
            th { background: #f3f4f6; }
            @media print { .no-print { display:none; } }
          </style>
        </head>
        <body>
          <button class="no-print" onclick="window.print()">Yazdır</button>
          <h1>${TT.title}</h1>
          <div class="muted">${new Date().toLocaleString("tr-TR")}</div>

          <div class="cards">
            <div class="card"><span>${TT.today}</span><b>${money(summary?.today_income, filteredRecords[0]?.currency || "TRY")}</b></div>
            <div class="card"><span>${TT.week}</span><b>${money(summary?.week_income, filteredRecords[0]?.currency || "TRY")}</b></div>
            <div class="card"><span>${TT.month}</span><b>${money(summary?.month_income, filteredRecords[0]?.currency || "TRY")}</b></div>
            <div class="card"><span>${TT.totalRecords}</span><b>${filteredRecords.length}</b></div>
          </div>

          <h2>${TT.list}</h2>
          <table>
            <tr>
              <th>${TT.date}</th>
              <th>${TT.titleField}</th>
              <th>${TT.category}</th>
              <th>${TT.type}</th>
              <th>${TT.quantity}</th>
              <th>${TT.total}</th>
              <th>${TT.paymentMethod}</th>
              <th>${TT.customer}</th>
              <th>${TT.staff}</th>
            </tr>
            ${filteredRecords
              .map(
                (r) => `
              <tr>
                <td>${String(r.transaction_date || "").slice(0, 10)}</td>
                <td>${r.title || "-"}</td>
                <td>${r.category || "-"}</td>
                <td>${r.transaction_type || "-"}</td>
                <td>${r.quantity || 0}</td>
                <td>${money(r.total_amount, r.currency)}</td>
                <td>${paymentLabels[r.payment_method]?.[lang] || r.payment_method || "-"}</td>
                <td>${r.customer_name || "-"}</td>
                <td>${r.staff_name || "-"}</td>
              </tr>`
              )
              .join("")}
          </table>
        </body>
      </html>
    `;

    const w = window.open("", "_blank");
    w.document.write(html);
    w.document.close();
  };

  if (loading) {
    return <div style={styles.loading}>Yükleniyor...</div>;
  }

 return (
  <div className="kasa-page" style={styles.page}>
    <div className="kasa-header" style={styles.header}>
        <div>
          <h1 style={styles.title}>{TT.title}</h1>
          <p style={styles.subtitle}>{TT.subtitle}</p>
        </div>

<div className="kasa-header-actions" style={styles.headerActions}>
          <button style={styles.secondaryBtn} onClick={exportCSV}>{TT.csv}</button>
          <button style={styles.primaryBtn} onClick={printReport}>{TT.print}</button>
        </div>
      </div>

<div className="kasa-stats-grid" style={styles.statsGrid}>
        <Stat title={TT.today} value={money(summary?.today_income, "TRY")} sub={`${TT.expense}: ${money(summary?.today_expense, "TRY")}`} />
        <Stat title={TT.week} value={money(summary?.week_income, "TRY")} />
        <Stat title={TT.month} value={money(summary?.month_income, "TRY")} />
        <Stat title={TT.cash} value={money(summary?.cash_total, "TRY")} />
        <Stat title={TT.card} value={money(summary?.card_total, "TRY")} />
        <Stat title={TT.bank} value={money(summary?.bank_total, "TRY")} />
        <Stat title={TT.totalRecords} value={summary?.total_count || 0} />
        <Stat title="Net" value={money(filteredTotals.income - filteredTotals.expense, "TRY")} />
      </div>

<section className="kasa-card" style={styles.card}>
        <h2 style={styles.cardTitle}>{editingId ? TT.edit : TT.add}</h2>

<div className="kasa-form-grid" style={styles.formGrid}>
          <Select label={TT.module} value={form.module_type} onChange={(v) => setForm({ ...form, module_type: v })} options={["manual", "beauty", "menu", "appointment"]} labels={moduleLabels} lang={lang} />
          <Select label={TT.type} value={form.transaction_type} onChange={(v) => setForm({ ...form, transaction_type: v })} options={["income", "expense"]} labels={{ income: TEXT[lang].income, expense: TEXT[lang].expense }} />
    <Input 
 label={TT.titleField}
 value={form.title}
 onChange={(v)=>setForm({...form,title:v})}
/>

<label style={styles.label}>
  {TT.customer}

  <select
    style={styles.input}
    value={form.customer_key}
    onChange={(e) => {
      const c = customers.find(
        (x) => String(x.display_key) === String(e.target.value)
      );

  const customerId =
  form.module_type === "beauty"
    ? c?.customer_id_for_beauty || ""
    : c?.customer_id_for_cash || "";

      setForm({
        ...form,
        customer_key: c?.display_key || "",
        customer_id: customerId,
        customer_name: c?.full_name || c?.name || "",
      });
    }}
  >
    <option value="">Müşteri seç</option>

    {customers.map((c) => (
      <option key={c.display_key} value={c.display_key}>
        {c.full_name || c.name || "-"} - {c.phone || ""} 
        {c.customer_source === "cari" ? " | Cari" : " | Beauty"}
      </option>
    ))}
  </select>
</label>


<Input
 label={TT.quantity}
 type="number"
 value={form.quantity}
 onChange={(v)=>
 setForm({
 ...form,
 quantity:v,
 total_amount:""
 })
 }
/>


<Input
 label={TT.unitPrice}
 type="number"
 value={form.unit_price}
 onChange={(v)=>
 setForm({
 ...form,
 unit_price:v,
 total_amount:""
 })
 }
/>


<label style={styles.label}>
{TT.total}

<div style={styles.totalBox}>
{money(calculatedTotal,form.currency)}
</div>

</label>


<Select
 label={TT.currency}
 value={form.currency}
 onChange={(v)=>setForm({...form,currency:v})}
 options={["TRY","CHF","EUR","USD"]}
/>


<Select
 label={TT.paymentMethod}
 value={form.payment_method}
 onChange={(v)=>setForm({...form,payment_method:v})}
 options={["cash","card","bank"]}
 labels={paymentLabels}
 lang={lang}
/>



<Input
 label={TT.staff}
 value={form.staff_name}
 onChange={(v)=>setForm({...form,staff_name:v})}
/>

          <Input label={TT.date} type="date" value={form.transaction_date} onChange={(v) => setForm({ ...form, transaction_date: v })} />
        </div>

        <Textarea label={TT.note} value={form.note} onChange={(v) => setForm({ ...form, note: v })} />

        <div style={styles.actions}>
          <button style={styles.primaryBtn} onClick={saveRecord}>
            {editingId ? TT.update : TT.save}
          </button>

          {editingId && (
            <button
              style={styles.secondaryBtn}
              onClick={() => {
                setEditingId(null);
                setForm(emptyForm);
              }}
            >
              {TT.cancel}
            </button>
          )}
        </div>
      </section>

    <section className="kasa-card" style={styles.card}>
  <h2 style={styles.cardTitle}>{TT.filter}</h2>

<div className="kasa-filter-grid" style={styles.filterGrid}>
          <Input label="Ara" value={filters.q} onChange={(v) => setFilters({ ...filters, q: v })} />
          <Select label={TT.type} value={filters.type} onChange={(v) => setFilters({ ...filters, type: v })} options={["all", "income", "expense"]} labels={{ all: TT.all, income: TT.income, expense: TT.expense }} />
          <Select label={TT.paymentMethod} value={filters.payment} onChange={(v) => setFilters({ ...filters, payment: v })} options={["all", "cash", "card", "bank"]} labels={{ all: TT.all, ...paymentLabels }} lang={lang} />
          <Select label={TT.module} value={filters.module} onChange={(v) => setFilters({ ...filters, module: v })} options={["all", "manual", "beauty", "menu", "appointment"]} labels={{ all: TT.all, ...moduleLabels }} lang={lang} />
          <Input label="Başlangıç" type="date" value={filters.start} onChange={(v) => setFilters({ ...filters, start: v })} />
          <Input label="Bitiş" type="date" value={filters.end} onChange={(v) => setFilters({ ...filters, end: v })} />
        </div>
      </section>

<div className="kasa-two-col" style={styles.twoCol}>
       <section className="kasa-card" style={styles.card}>
  <h2 style={styles.cardTitle}>{TT.list}</h2>

          {filteredRecords.length === 0 ? (
            <div style={styles.empty}>{TT.noRecord}</div>
          ) : (
<div className="kasa-table-wrap" style={styles.tableWrap}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th>{TT.date}</th>
                    <th>{TT.titleField}</th>
                    <th>{TT.category}</th>
                    <th>{TT.type}</th>
                    <th>{TT.total}</th>
                    <th>{TT.paymentMethod}</th>
                    <th>{TT.customer}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRecords.map((r) => (
                    <tr key={r.id}>
                      <td>{String(r.transaction_date || "").slice(0, 10)}</td>
                      <td>
                        <b>{r.title}</b>
                        <div style={styles.small}>{moduleLabels[r.module_type]?.[lang] || r.module_type}</div>
                      </td>
                      <td>{r.category || "-"}</td>
                      <td>
                        <span style={r.transaction_type === "expense" ? styles.expenseBadge : styles.incomeBadge}>
                          {r.transaction_type === "expense" ? TT.expense : TT.income}
                        </span>
                      </td>
                      <td><b>{money(r.total_amount, r.currency)}</b></td>
                      <td>{paymentLabels[r.payment_method]?.[lang] || r.payment_method}</td>
                      <td>{r.customer_name || "-"}</td>
                      <td>
                        <div style={styles.rowActions}>
                          <button style={styles.editBtn} onClick={() => editRecord(r)}>{TT.edit}</button>
                          <button style={styles.deleteBtn} onClick={() => deleteRecord(r.id)}>{TT.delete}</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>

    <section className="kasa-card" style={styles.card}>
  <h2 style={styles.cardTitle}>{TT.topItems}</h2>

          {topItems.length === 0 ? (
            <div style={styles.empty}>{TT.noRecord}</div>
          ) : (
            <div style={styles.topList}>
              {topItems.map((item, index) => (
                <div key={`${item.title}-${index}`} style={styles.topItem}>
                  <div>
                    <b>{index + 1}. {item.title}</b>
                    <div style={styles.small}>{item.category || "-"}</div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <b>{money(item.total, "TRY")}</b>
                    <div style={styles.small}>{Number(item.quantity || 0)} adet</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>
      </div>
    </div>
  );
}

function Stat({ title, value, sub }) {
  return (
    <div style={styles.stat}>
      <span style={styles.statLabel}>{title}</span>
      <b style={styles.statValue}>{value}</b>
      {sub && <small style={styles.statSub}>{sub}</small>}
    </div>
  );
}

function Input({ label, value, onChange, type = "text" }) {
  return (
    <label style={styles.label}>
      {label}
      <input type={type} value={value || ""} onChange={(e) => onChange(e.target.value)} style={styles.input} />
    </label>
  );
}

function Textarea({ label, value, onChange }) {
  return (
    <label style={styles.label}>
      {label}
      <textarea value={value || ""} onChange={(e) => onChange(e.target.value)} style={{ ...styles.input, minHeight: 90 }} />
    </label>
  );
}

function Select({ label, value, onChange, options, labels = {}, lang = "tr" }) {
  const renderLabel = (opt) => {
    const raw = labels?.[opt];
    if (!raw) return opt;
    if (typeof raw === "string") return raw;
    return raw?.[lang] || raw?.tr || opt;
  };

  return (
    <label style={styles.label}>
      {label}
      <select value={value || ""} onChange={(e) => onChange(e.target.value)} style={styles.input}>
        {options.map((o) => (
          <option key={o} value={o}>
            {renderLabel(o)}
          </option>
        ))}
      </select>
    </label>
  );
}





const styles = {
  page: {
    width: "100%",
    maxWidth: "100%",
    overflowX: "hidden",
    padding: 24,
    background:
      "radial-gradient(circle at top left, rgba(11,77,139,0.10), transparent 32%), radial-gradient(circle at top right, rgba(245,130,32,0.12), transparent 30%), linear-gradient(145deg, #f8fafc 0%, #eef2f7 100%)",
    minHeight: "100vh",
    color: "#0f172a",
    fontFamily:
      "system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif",
  },

  loading: {
    padding: 50,
    fontWeight: 900,
    textAlign: "center",
    color: "#0B4D8B",
  },

  header: {
    background:
      "linear-gradient(135deg, #ffffff 0%, #f8fbff 52%, #fff3e6 100%)",
    color: "#0f172a",
    borderRadius: 28,
    padding: 28,
    display: "flex",
    justifyContent: "space-between",
    gap: 18,
    alignItems: "center",
    flexWrap: "wrap",
    boxShadow: "0 24px 70px rgba(15,23,42,.10)",
    border: "1px solid rgba(15,23,42,.08)",
    marginBottom: 22,
    position: "relative",
    overflow: "hidden",
  },

  title: {
    margin: 0,
    fontSize: 32,
    fontWeight: 950,
    letterSpacing: -0.8,
    background: "linear-gradient(135deg,#0B4D8B,#F58220)",
    WebkitBackgroundClip: "text",
    backgroundClip: "text",
    color: "transparent",
  },

  subtitle: {
    margin: "8px 0 0",
    color: "#64748b",
    fontWeight: 650,
    lineHeight: 1.5,
  },

  headerActions: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
    alignItems: "center",
  },

  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(230px,1fr))",
    gap: 18,
    marginBottom: 24,
  },

  stat: {
    background:
      "linear-gradient(180deg, rgba(255,255,255,.98) 0%, rgba(11,77,139,.045) 100%)",
    border: "1px solid rgba(15,23,42,.08)",
    borderRadius: 22,
    padding: 20,
    boxShadow: "0 18px 46px rgba(15,23,42,.08)",
    minHeight: 115,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 8,
    position: "relative",
    overflow: "hidden",
  },

  statLabel: {
    fontSize: 13,
    fontWeight: 900,
    color: "#64748b",
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },

  statValue: {
    fontSize: 23,
    fontWeight: 950,
    color: "#0B4D8B",
    lineHeight: 1.14,
    wordBreak: "break-word",
    letterSpacing: -0.5,
  },

  statSub: {
    fontSize: 12,
    fontWeight: 800,
    color: "#F58220",
    lineHeight: 1.3,
  },

  card: {
    background: "#fff",
    borderRadius: 24,
    border: "1px solid rgba(15,23,42,.08)",
    boxShadow: "0 18px 45px rgba(15,23,42,.08)",
    padding: 22,
    marginBottom: 20,
    overflow: "hidden",
  },

  cardTitle: {
    marginTop: 0,
    marginBottom: 18,
    fontSize: 22,
    fontWeight: 950,
    letterSpacing: -0.4,
    color: "#0f172a",
  },

  formGrid: {
  display: "grid",
  gridTemplateColumns: "repeat(12,minmax(0,1fr))",
  gap: 14,
  marginBottom: 14,
},

filterGrid: {
  display: "grid",
  gridTemplateColumns: "repeat(12,minmax(0,1fr))",
  gap: 14,
},

  twoCol: {
    display: "grid",
    gridTemplateColumns: "minmax(0,2fr) minmax(280px,1fr)",
    gap: 20,
  },

  label: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
    fontWeight: 850,
    color: "#334155",
    fontSize: 13,
  },

  input: {
    border: "1px solid #dbe3ef",
    borderRadius: 14,
    padding: "12px 13px",
    outline: "none",
    fontSize: 14,
    background: "#fff",
    color: "#0f172a",
    boxShadow: "0 4px 12px rgba(15,23,42,.035)",
  },

  actions: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
    marginTop: 14,
  },

  primaryBtn: {
    border: "none",
    background: "linear-gradient(135deg,#F58220,#e46f12)",
    color: "#fff",
    padding: "12px 18px",
    borderRadius: 14,
    fontWeight: 950,
    cursor: "pointer",
    boxShadow: "0 14px 28px rgba(245,130,32,.25)",
  },

  secondaryBtn: {
    border: "1px solid rgba(11,77,139,.25)",
    background: "#fff",
    color: "#0B4D8B",
    padding: "12px 18px",
    borderRadius: 14,
    fontWeight: 950,
    cursor: "pointer",
    boxShadow: "0 8px 20px rgba(15,23,42,.05)",
  },

  editBtn: {
    border: "none",
    background: "#0B4D8B",
    color: "#fff",
    padding: "8px 11px",
    borderRadius: 10,
    fontWeight: 850,
    cursor: "pointer",
  },

  deleteBtn: {
    border: "none",
    background: "#ef4444",
    color: "#fff",
    padding: "8px 11px",
    borderRadius: 10,
    fontWeight: 850,
    cursor: "pointer",
  },

  tableWrap: {
    overflowX: "auto",
    width: "100%",
    maxWidth: "100%",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: 850,
  },

  rowActions: {
    display: "flex",
    gap: 6,
    flexWrap: "wrap",
  },

  incomeBadge: {
    background: "#dcfce7",
    color: "#166534",
    padding: "5px 9px",
    borderRadius: 999,
    fontWeight: 950,
    fontSize: 12,
  },

  expenseBadge: {
    background: "#fee2e2",
    color: "#991b1b",
    padding: "5px 9px",
    borderRadius: 999,
    fontWeight: 950,
    fontSize: 12,
  },

  empty: {
    background: "#f8fafc",
    border: "1px dashed #cbd5e1",
    padding: 22,
    borderRadius: 16,
    textAlign: "center",
    fontWeight: 850,
    color: "#64748b",
  },

  topList: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },

  topItem: {
    display: "flex",
    justifyContent: "space-between",
    gap: 12,
    border: "1px solid rgba(15,23,42,.08)",
    borderRadius: 16,
    padding: 14,
    background: "linear-gradient(180deg,#ffffff,#f8fafc)",
  },

  totalBox: {
    border: "1px solid #dbe3ef",
    borderRadius: 14,
    padding: "12px 13px",
    background: "#f8fafc",
    fontSize: 15,
    fontWeight: 950,
    color: "#0B4D8B",
  },

  small: {
    color: "#64748b",
    fontSize: 12,
    marginTop: 3,
  },
};








const styleTag = document.createElement("style");
styleTag.innerHTML = `
  .kasa-page,
  .kasa-page * {
    box-sizing: border-box;
  }

  .kasa-page {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
  }

  .kasa-header::after {
    content: "";
    position: absolute;
    right: -70px;
    top: -70px;
    width: 210px;
    height: 210px;
    border-radius: 999px;
    background: rgba(245,130,32,.13);
    pointer-events: none;
  }

  .kasa-header > * {
    position: relative;
    z-index: 1;
  }

  .kasa-card,
  .kasa-header,
  .kasa-stats-grid,
  .kasa-form-grid,
  .kasa-filter-grid,
  .kasa-two-col {
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .kasa-card {
    position: relative;
  }

  .kasa-card::before {
    content: "";
    display: block;
    height: 5px;
    width: calc(100% + 44px);
    margin: -22px -22px 16px;
    background: linear-gradient(90deg,#0B4D8B,#F58220);
  }

  .kasa-form-grid > *,
  .kasa-filter-grid > *,
  .kasa-two-col > * {
    min-width: 0;
    max-width: 100%;
  }

  .kasa-page input,
  .kasa-page select,
  .kasa-page textarea {
    width: 100%;
    max-width: 100%;
    transition: border-color .18s ease, box-shadow .18s ease, transform .18s ease;
  }

  .kasa-page input:focus,
  .kasa-page select:focus,
  .kasa-page textarea:focus {
    border-color: #0B4D8B !important;
    box-shadow: 0 0 0 3px rgba(11,77,139,.10) !important;
  }

  .kasa-page button {
    transition: transform .18s ease, box-shadow .18s ease, opacity .18s ease;
  }

  .kasa-page button:hover {
    transform: translateY(-1px);
  }

  table th {
    background: #f8fafc;
    color: #334155;
    font-size: 12px;
    padding: 11px 10px;
    text-align: left;
    border-bottom: 1px solid #e5e7eb;
    white-space: nowrap;
    font-weight: 950;
  }

  table td {
    padding: 11px 10px;
    border-bottom: 1px solid #e5e7eb;
    vertical-align: top;
    font-size: 13px;
    white-space: nowrap;
    color: #0f172a;
  }

  tbody tr:hover {
    background: #f8fafc;
  }

  .kasa-table-wrap {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    border-radius: 16px;
    border: 1px solid #eef2f7;
  }

  .kasa-two-col {
    width: 100%;
    max-width: 100%;
  }

  .kasa-two-col > .kasa-card {
    min-width: 0;
    max-width: 100%;
  }

  @media (max-width: 1200px) {
    .kasa-two-col {
      grid-template-columns: 1fr !important;
    }
  }

  @media (max-width: 900px) {
    html,
    body {
      overflow-x: hidden !important;
    }

    .kasa-page {
      padding: 8px !important;
      background: #f6f8fb !important;
    }

    .kasa-header {
      border-radius: 18px !important;
      padding: 14px !important;
      margin-bottom: 10px !important;
      box-shadow: 0 10px 26px rgba(15,23,42,.08) !important;
    }

    .kasa-header::after {
      right: -95px;
      top: -95px;
      width: 170px;
      height: 170px;
    }

    .kasa-header h1 {
      font-size: 22px !important;
      line-height: 1.12 !important;
      letter-spacing: -.5px !important;
    }

    .kasa-header p {
      font-size: 12px !important;
      line-height: 1.42 !important;
      max-width: 100%;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .kasa-header-actions {
      width: 100% !important;
      display: grid !important;
      grid-template-columns: 1fr 1fr !important;
      gap: 8px !important;
    }

    .kasa-header-actions button {
      width: 100% !important;
      min-height: 42px !important;
      border-radius: 12px !important;
      font-size: 12px !important;
      padding: 8px 9px !important;
      white-space: nowrap !important;
    }

    .kasa-stats-grid {
      display: grid !important;
      grid-template-columns: repeat(2,minmax(0,1fr)) !important;
      gap: 9px !important;
      margin-bottom: 10px !important;
    }

    .kasa-stats-grid > * {
      min-width: 0 !important;
      max-width: 100% !important;
    }

    .kasa-stats-grid > div {
      min-height: 104px !important;
      border-radius: 16px !important;
      padding: 11px !important;
      box-shadow: 0 8px 20px rgba(15,23,42,.06) !important;
    }

    .kasa-stats-grid span {
      font-size: 11px !important;
      line-height: 1.2 !important;
    }

    .kasa-stats-grid b {
      font-size: 18px !important;
      line-height: 1.08 !important;
      word-break: break-word !important;
    }

    .kasa-stats-grid small {
      font-size: 10px !important;
      line-height: 1.2 !important;
    }

    .kasa-card {
      border-radius: 18px !important;
      padding: 14px !important;
      margin-bottom: 10px !important;
      box-shadow: 0 8px 22px rgba(15,23,42,.07) !important;
    }

    .kasa-card::before {
      height: 4px;
      width: calc(100% + 28px);
      margin: -14px -14px 12px;
    }

    .kasa-card h2 {
      font-size: 18px !important;
      margin-bottom: 12px !important;
    }

    .kasa-form-grid,
    .kasa-filter-grid {
      display: grid !important;
      grid-template-columns: 1fr !important;
      gap: 10px !important;
    }

    .kasa-page label {
      font-size: 12px !important;
      gap: 5px !important;
    }

    .kasa-page input,
    .kasa-page select,
    .kasa-page textarea {
      min-height: 42px !important;
      border-radius: 12px !important;
      font-size: 13px !important;
      padding: 10px 11px !important;
    }

    .kasa-page textarea {
      min-height: 76px !important;
    }

    .kasa-page button {
      min-height: 40px !important;
      border-radius: 12px !important;
      font-size: 12px !important;
    }

    .kasa-two-col {
      grid-template-columns: 1fr !important;
      gap: 10px !important;
    }

    .kasa-two-col > .kasa-card {
      width: 100% !important;
      max-width: 100% !important;
      margin-bottom: 10px !important;
    }

    .kasa-table-wrap {
      overflow-x: auto !important;
      border-radius: 14px !important;
    }

    table {
      min-width: 820px !important;
    }

    table th,
    table td {
      font-size: 12px !important;
      padding: 9px !important;
    }

    .kasa-page [style*="justify-content: space-between"] {
      min-width: 0 !important;
    }
  }

 @media (max-width: 430px) {
  .kasa-stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .kasa-form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .kasa-filter-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .kasa-header-actions {
    grid-template-columns: 1fr 1fr !important;
  }

  .kasa-header h1 {
    font-size: 20px !important;
  }
}
  /* =====================================================
     ✅ KASA PANEL - 2'Lİ MOBİL KART + KULLANIŞLI FORM FINAL
     ===================================================== */

  .kasa-stats-grid {
    grid-template-columns: repeat(4,minmax(0,1fr)) !important;
  }

  .kasa-form-grid > *,
  .kasa-filter-grid > * {
    min-width: 0 !important;
    max-width: 100% !important;
  }

  .kasa-form-grid > label,
  .kasa-filter-grid > label {
    grid-column: span 3;
  }

  /* İşlem başlığı, müşteri seçimi ve uzun alanlar geniş dursun */
  .kasa-form-grid > label:nth-child(3),
  .kasa-form-grid > label:nth-child(4),
  .kasa-form-grid > label:nth-child(10) {
    grid-column: span 6;
  }

  /* Filtrelerde arama ve tarih alanları daha dengeli */
  .kasa-filter-grid > label:nth-child(1) {
    grid-column: span 4;
  }

  .kasa-filter-grid > label:nth-child(5),
  .kasa-filter-grid > label:nth-child(6) {
    grid-column: span 2;
  }

  @media (max-width: 1200px) {
    .kasa-stats-grid {
      grid-template-columns: repeat(3,minmax(0,1fr)) !important;
    }

    .kasa-form-grid > label,
    .kasa-filter-grid > label {
      grid-column: span 4;
    }

    .kasa-form-grid > label:nth-child(3),
    .kasa-form-grid > label:nth-child(4),
    .kasa-form-grid > label:nth-child(10),
    .kasa-filter-grid > label:nth-child(1) {
      grid-column: span 8;
    }
  }

  @media (max-width: 900px) {
    /* Bugün / Bu hafta / Bu ay / Nakit... mobilde 2'li */
    .kasa-stats-grid {
      display: grid !important;
      grid-template-columns: repeat(2,minmax(0,1fr)) !important;
      gap: 9px !important;
      margin-bottom: 10px !important;
    }

    .kasa-stats-grid > div {
      min-width: 0 !important;
      max-width: 100% !important;
      width: 100% !important;
      min-height: 104px !important;
      border-radius: 16px !important;
      padding: 11px !important;
    }

    .kasa-stats-grid span {
      font-size: 11px !important;
      line-height: 1.2 !important;
    }

    .kasa-stats-grid b {
      font-size: 18px !important;
      line-height: 1.08 !important;
      word-break: break-word !important;
    }

    .kasa-stats-grid small {
      font-size: 10px !important;
      line-height: 1.2 !important;
    }

    /* İşlem ekle: kısa alanlar 2'li, uzunlar tam genişlik */
    .kasa-form-grid {
      display: grid !important;
      grid-template-columns: repeat(2,minmax(0,1fr)) !important;
      gap: 10px !important;
      width: 100% !important;
    }

    .kasa-form-grid > label {
      grid-column: auto !important;
      min-width: 0 !important;
      max-width: 100% !important;
    }

    /* Başlık, müşteri seçimi ve ikinci müşteri alanı tam genişlik */
    .kasa-form-grid > label:nth-child(3),
    .kasa-form-grid > label:nth-child(4),
    .kasa-form-grid > label:nth-child(10) {
      grid-column: 1 / -1 !important;
    }

    /* Not alanı zaten formGrid dışında; tam genişlik kalsın */
    .kasa-card > label {
      width: 100% !important;
      max-width: 100% !important;
    }

    /* Filtreler de 2'li, arama tam genişlik */
    .kasa-filter-grid {
      display: grid !important;
      grid-template-columns: repeat(2,minmax(0,1fr)) !important;
      gap: 10px !important;
      width: 100% !important;
    }

    .kasa-filter-grid > label {
      grid-column: auto !important;
      min-width: 0 !important;
      max-width: 100% !important;
    }

    .kasa-filter-grid > label:nth-child(1) {
      grid-column: 1 / -1 !important;
    }

    .kasa-page input,
    .kasa-page select,
    .kasa-page textarea {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      min-height: 42px !important;
      border-radius: 12px !important;
      font-size: 13px !important;
      padding: 10px 11px !important;
    }

    .kasa-page label {
      min-width: 0 !important;
      max-width: 100% !important;
      font-size: 12px !important;
      gap: 5px !important;
    }

    .kasa-page button {
      min-height: 40px !important;
      border-radius: 12px !important;
      font-size: 12px !important;
    }

    .kasa-actions,
    .kasa-page div[style*="flex-wrap"] {
      max-width: 100% !important;
    }
  }

  @media (max-width: 430px) {
    /* 430 altında da 2'li kalsın, liste uzamasın */
    .kasa-stats-grid {
      grid-template-columns: repeat(2,minmax(0,1fr)) !important;
    }

    .kasa-form-grid {
      grid-template-columns: repeat(2,minmax(0,1fr)) !important;
    }

    .kasa-filter-grid {
      grid-template-columns: repeat(2,minmax(0,1fr)) !important;
    }

    .kasa-header-actions {
      grid-template-columns: 1fr 1fr !important;
    }
  }

  @media (max-width: 360px) {
    /* Çok küçük telefonlarda taşma olursa güvenlik */
    .kasa-form-grid,
    .kasa-filter-grid {
      grid-template-columns: 1fr !important;
    }

    .kasa-stats-grid {
      grid-template-columns: repeat(2,minmax(0,1fr)) !important;
    }
  }

`;





if (typeof document !== "undefined" && !document.getElementById("kasa-panel-style")) {
  styleTag.id = "kasa-panel-style";
  document.head.appendChild(styleTag);
}


